module.exports = __webpack_public_path__ + "static/media/online-tutoring.84d20c18.jpg";